var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCopyTool = function SvgCopyTool(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.667 4V2a.667.667 0 01.666-.667h8A.667.667 0 0114 2v9.333a.666.666 0 01-.667.667h-2v2c0 .368-.3.666-.671.666h-7.99A.667.667 0 012 14l.002-9.334c0-.368.3-.666.671-.666h1.994zM3.335 5.333l-.002 8H10v-8H3.335zM6 4h4.533a.8.8 0 01.8.8v5.866h1.334v-8H6V4z",
    fill: "#666"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "copy-tool_svg__clip0_240_4393"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
};
export default SvgCopyTool;